const formatNumber = (number) => {
  if (number === undefined) return null;
  // eslint-disable-next-line use-isnan
  if (Number.isNaN(number)) return '0';

  const absoluteNumber = Math.abs(number);

  if (absoluteNumber < 1e-10) return '0';

  if (absoluteNumber > 1e6 || (absoluteNumber < 0.01 && number !== 0))
    return Number(number).toExponential(2);

  return number.toLocaleString('fr-FR', {
    maximumFractionDigits: 2,
  });
};

export default formatNumber;
